module.exports = __webpack_public_path__ + "img/instagramestory5-1.64ab782e.jpg";